export default "__VITE_ASSET__DTOXoioO__"